var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBattery0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60135 16.5C4.4527 16.5 3.47973 16.3936 2.79054 15.7151C2.10135 15.0366 2 14.092 2 12.9545V11.0255C2 9.91463 2.10135 8.96341 2.79054 8.28492C3.47973 7.60643 4.4527 7.5 5.58784 7.5H16.223C17.3784 7.5 18.3514 7.60643 19.0405 8.28492C19.7297 8.96341 19.8311 9.90798 19.8311 11.0455V12.9545C19.8311 14.092 19.7297 15.0366 19.0405 15.7151C18.3514 16.3936 17.3784 16.5 16.223 16.5H5.60135ZM5.41892 15.429H16.4122C17.1081 15.429 17.8378 15.3359 18.2432 14.9368C18.6554 14.531 18.7432 13.8193 18.7432 13.1341V10.8592C18.7432 10.1741 18.6554 9.46896 18.2432 9.06319C17.8378 8.66408 17.1081 8.57095 16.4122 8.57095H5.43919C4.72973 8.57095 3.99324 8.65743 3.58108 9.06319C3.17568 9.46896 3.08784 10.1807 3.08784 10.8792V13.1341C3.08784 13.8193 3.17568 14.531 3.58108 14.9368C3.99324 15.3359 4.72297 15.429 5.41892 15.429ZM20.75 13.7195V10.2805C21.2838 10.3137 22 10.9856 22 11.9967C22 13.0144 21.2838 13.6863 20.75 13.7195Z",
    fill: "#2D3D50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery0);
export default __webpack_public_path__ + "static/media/Battery0.80bf33d78cb06f59a695334628778e83.svg";
export { ForwardRef as ReactComponent };